<div [class]="listingBackground">
  <a class="business-summary__name" [routerLink]="['/business', business.id]">{{business.name}}</a>
  <a [routerLink]="['/business', business.id]"><app-review-overview *ngIf="business.reviewSummary"
    [reviewSummary]="business.reviewSummary" [sizeModifier]="'_small'"
    [noReviewsText]="'Be the first to review this business'"></app-review-overview></a>
  <div class="business-summary__label" *ngIf="(tagsToDisplay && tagsToDisplay.length > 0) || (oldTagsToDisplay && oldTagsToDisplay.length > 0) || displayReportCard">Awards and Recognition:</div>
  <div class="business-summary__awards" *ngIf="(tagsToDisplay && tagsToDisplay.length > 0) || (oldTagsToDisplay && oldTagsToDisplay.length > 0) || displayReportCard">
    <ul class="business-summary__awards-list">
      <li *ngFor="let awardTag of tagsToDisplay" class="business-summary__awards-image-container">
        <img class="business-summary__awards-image" src="{{getBadgeImageUrl(awardTag.tagName)}}" title="{{getAwardName(awardTag.tagName)}}">
      </li>
      <br *ngIf="tagsToDisplay.length > 0 && oldTagsToDisplay.length > 0">
      <li *ngFor="let awardTag of oldTagsToDisplay" class="business-summary__awards-image-container">
        <img class="business-summary__awards-image-old" src="{{getBadgeImageUrl(awardTag.tagName)}}" title="{{getAwardName(awardTag.tagName)}}">
      </li>
      <li *ngIf="displayReportCard" class="business-summary__report-image-container">
        <img class="business-summary__report-image" src="{{getReportCardBadgeUrl()}}" (click)="clickReportCard()">
      </li>
    </ul>
  </div>
  <a [routerLink]="['/business', business.id]">
    <div class="business-summary__fields">
      <div class="business-summary__field business-summary__field--services">
        <div class="business-summary__label">Services Offered:</div>
        <div class="business-summary__value">
          <ng-container *ngIf="hasServices; else na">
            <app-service-badge *ngIf="business.maintenance" [service]="'maintenance'" [text]="'Maintenance'"></app-service-badge>
          	<app-service-badge *ngIf="business.rental.planes" [service]="'plane'" [text]="'Plane Rental'"></app-service-badge>
          	<app-service-badge *ngIf="business.rental.rotorcraft" [service]="'rotorcraft'" [text]="'Rotorcraft Rental'"></app-service-badge>
          	<app-service-badge *ngIf="business.rental.equipment" [service]="'equipment'" [text]="'Equipment Rental'"></app-service-badge>
          	<app-service-badge *ngIf="business.rental.cars" [service]="'cars'" [text]="'Car Rental'"></app-service-badge>
            <app-service-badge *ngIf="business.sales" [service]="'sales'" [text]="'Sales'"></app-service-badge>
            <app-service-badge *ngIf="business.flightTraining" [service]="'training'" [text]="'Flight Training'"></app-service-badge>
            <app-fuel-badge *ngFor="let fuel of business.fuel" [fuel]="fuel"></app-fuel-badge>
          </ng-container>
        </div>
      </div>
      <div class="business-summary__field business-summary__field--location">
        <div class="business-summary__label">Location:</div>
        <div class="business-summary__value_text">
        <span *ngIf="business.locationOnField; else cityState">
          On field: {{business.locationOnField}}
        </span>
          <ng-template #cityState>
          <span *ngIf="business.city && business.state; else na">
            {{business.city}}, {{business.state}}
          </span>
          </ng-template>
        </div>
      </div>
      <div class="business-summary__field business-summary__field--phone">
        <div class="business-summary__label">Phone:</div>
        <div class="business-summary__value_text">
          <span *ngIf="business.phone1; else na">{{business.phone1 | phone}}</span>
        </div>
      </div>
      <div class="business-summary__field business-summary__field--frequencies">
        <div class="business-summary__label">Freq. Monitored:</div>
        <div class="business-summary__value_text">
          <span *ngIf="business.unicomFreq">UNICOM: {{business.unicomFreq}}<br /></span>
          <span *ngIf="business.airincFreq">ASRI: {{business.airincFreq}}</span>
        </div>
      </div>
    </div>
  </a>
</div>
<a [routerLink]="['/business', business.id]" [fragment]="'fees'" *ngIf="fboFees && fboFees.length > 0">
  <div class="business-summary__fields">
    <div class="business-summary__field business-summary__field--services">
      <div class="business-summary__label">Fees:</div>
      <div class="business-summary__value_fees">{{ fboFees }}</div>
    </div>
  </div>
</a>
<ng-template #na>
  <span class="business-summary__empty-value">N/A</span>
</ng-template>
